export default {
    methods: {
        async changeTypeDocumentSelect(typeDocument) {
            this.form.document = await null
            this.form.social_name = await null
        },
    }
}
